module.exports = __webpack_public_path__ + "img/coupon_yk_bg.53fd37cb.webp";